import { render, staticRenderFns } from "./Estrutura.vue?vue&type=template&id=0b57a431&scoped=true"
import script from "./Estrutura.vue?vue&type=script&lang=js"
export * from "./Estrutura.vue?vue&type=script&lang=js"
import style0 from "./Estrutura.vue?vue&type=style&index=0&id=0b57a431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57a431",
  null
  
)

export default component.exports